export enum AggregationIntervalsEnum {
   'Auto' = 0,
   '30 seconds' = 30,
   '1 minute' = 60,
   '5 minutes' = 60 * 5,
   '10 minutes' = 60 * 10,
   '15 minutes' = 60 * 15,
   '30 minutes' = 60 * 30,
   '1 hour' = 60 * 60,
   '2 hour' = (60 * 60) * 2,
   '4 hour' = (60 * 60) * 4,
   '6 hour' = (60 * 60) * 6,
   '12 hour' = (60 * 60) * 12,
   '1 day' = (60 * 60) * 24,
   '2 day' = (60 * 60) * 48,
   '7 days' = ((60 * 60) * 24) * 7,
   '1 month' = ((60 * 60) * 24) * 30,
}